import '../_main/Profile.sass'

import { FC, Fragment, useEffect } from 'react'

import { GalleryHeader } from 'components/common/Gallery/GalleryHeader'
import { Outlet } from 'react-router-dom'
import { PageHeader } from 'components/common/Page/PageHeader'
import { PageLayout } from 'components/common/Page/PageLayout'
import { PageTransition } from 'utils/animations'
import { UserRole } from 'constants/auth'
import { logAnalyticsEvent } from 'utils/analytics'
import { useAuth0 } from 'utils/auth'
import { useTranslation } from 'react-i18next'

export const ProfilePageController: FC = () => {
  const { t } = useTranslation(['profile'])
  const { user, roles } = useAuth0()

  useEffect(() => {
    let currentUserRole = UserRole.CLIENT

    if (roles.isCreative) currentUserRole = UserRole.CREATIVE
    if (roles.isAdmin) currentUserRole = UserRole.ADMIN

    logAnalyticsEvent('profile_page_opened', {
      userRole: currentUserRole,
    })
  }, [roles.isAdmin, roles.isClient, roles.isCreative])

  if (!user) return <Fragment></Fragment>

  return (
    <PageTransition>
      <PageLayout
        layoutErrorContent={null}
        header={
          <PageHeader>
            <GalleryHeader title={t('settings')} />
          </PageHeader>
        }
      >
        <Outlet />
      </PageLayout>
    </PageTransition>
  )
}
